var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEthur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.145 36.29C8.12329 36.29 0 28.1667 0 18.145C0 8.12329 8.12329 0 18.145 0C28.1667 0 36.29 8.12329 36.29 18.145C36.29 28.1667 28.1667 36.29 18.145 36.29ZM27.2107 18.3934L18.7098 4.53625L10.2066 18.3945L18.7098 23.3311L27.2107 18.3934ZM27.2175 19.9776L18.7098 24.912L10.2066 19.9788L18.7098 31.7481L27.2175 19.9776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7098 4.53625V14.5954L27.2118 18.3945L18.7098 4.53625ZM18.7098 24.9131V31.7481L27.2175 19.9776L18.7098 24.9131Z",
    fill: "black",
    fillOpacity: 0.298
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7098 23.3311L27.2118 18.3945L18.7098 14.5977V23.3311Z",
    fill: "black",
    fillOpacity: 0.801
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2065 18.3945L18.7097 23.3311V14.5977L10.2065 18.3945Z",
    fill: "black",
    fillOpacity: 0.298
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthur);
export default __webpack_public_path__ + "static/media/icon-ethur.9f378de29075376e7c4f9dc737f66973.svg";
export { ForwardRef as ReactComponent };